import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router';
import invariant from 'tiny-invariant';

import type { Contact } from '~/api/clients/types';
import type { Params } from '~/providers/RouterProvider/router.types';

import { AlertDialog, Button, Menu } from '~/components';
import { optionsMenuTriggerStyle } from '~/components/Table/TableRow.css';
import { r, routes } from '~/providers/RouterProvider/router.routes';

import type { DialogHandles } from '../ContactsTable.hooks';

type Props = {
  contact: Contact;
  dialogHandles: DialogHandles;
};

export const ContactOptionsCell = ({ contact, dialogHandles }: Props) => {
  const { clientId } = useParams<Params<typeof routes.showClient>>();
  invariant(clientId, 'Missing clientId in route parameters.');

  const navigate = useNavigate();
  const { t } = useTranslation(['common', 'clients']);

  return (
    <Menu.Root>
      <Menu.Trigger render={<Button aria-label={t('common:actions.openMenu')} className={optionsMenuTriggerStyle} icon="MoreVert" />} />

      <Menu.List>
        <Menu.Item icon="Edit" onClick={() => navigate(r(routes.editContact, { clientId, contactId: contact.id }))}>
          {t('common:actions.edit')}
        </Menu.Item>

        <Menu.Item
          icon="EditDocument"
          onClick={() => navigate(r(routes.createContact, { clientId }), { state: { duplicateContact: contact } })}
        >
          {t('clients:detail.contacts.rowActions.duplicate')}
        </Menu.Item>

        <AlertDialog.Trigger
          handle={dialogHandles.deleteContactHandle}
          nativeButton={false}
          payload={contact}
          render={<Menu.Item icon="Trash">{t('common:actions.delete')}</Menu.Item>}
        />
      </Menu.List>
    </Menu.Root>
  );
};
